import { contact7 }  from './utils/contacts7.js';
import { modal }     from './utils/modal.js';
import { Tabs }      from './components/Tabs.js';
import accordion   from './components/Accordion.js';
import MainMenu    from './components/MainMenu.js';
import anim        from './utils/anim.js';
import { DropPanel } from './components/DropPanel.js';

document.addEventListener('DOMContentLoaded', () => {
    contact7();
    modal();
    const tabs = new Tabs();
    tabs.init();
    accordion();
    new MainMenu({});
    anim();
    const dropdown = new DropPanel();
    dropdown.init();
});
